<div class="container" style="text-align: center;">
    <p><i class="fa fa-check-circle" style="color:green; font-size: 65px; margin-top: 60px;"></i></p>
    <h3>Thank you for ordering from us</h3>

    <h6 style="color: gray;">You will receive a confirmation EMAIL OR SMS from us soon.</h6>
    <p>
        <a [routerLink]="['/our-products']">Shop more</a>
    </p>
</div>